/** interval in milliseconds used to get the current time,
 *  because has the current time is an impure function */
export const TIME_REFRESH_NOW = 1000 * 60 * 30;
